import { Moon, Sun } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useUiThemeDark } from '@/hooks/useUiThemeDark';
import { useUIStore } from '@/stores/ui.store';

export function HeaderThemeToggle({ buttonClassName = '' }: { buttonClassName?: string }) {
  const { t } = useTranslation();
  const uiThemeDark = useUiThemeDark();
  const label = t('header.toggleTheme', 'Changer le thème clair ou sombre');

  return (
    <button
      type="button"
      aria-label={label}
      title={label}
      onClick={() => useUIStore.getState().setTheme(uiThemeDark ? 'light' : 'dark')}
      className={`flex items-center justify-center rounded-xl px-3 py-2 text-[#475569] transition-colors hover:bg-[#F8FAFC] hover:text-[#0F172A] dark:text-slate-200 dark:hover:bg-white/10 dark:hover:text-white ${buttonClassName}`}
    >
      {uiThemeDark ? <Sun className="h-4 w-4" aria-hidden /> : <Moon className="h-4 w-4" aria-hidden />}
    </button>
  );
}
